'use client';

import { useEffect } from 'react';
import { setUser, type User } from '@sentry/nextjs';

type Props = {
  user: User | null;
};

// Soft navigation never re-renders the root layout, so an in-place session expiry keeps the stale user.
export const SentryUserSync = ({ user }: Props) => {
  useEffect(() => {
    setUser(user);
  }, [user]);

  return null;
};
